import { isNil } from 'lodash';

export function Nullish({ value, nullValue = '—' }: { value: any; nullValue?: string }) {
  return isNil(value) ? nullValue : value;
}
